var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ct container terms"},[_c('titletag',{attrs:{"title":"FunditOn Terms and Conditions"}}),_vm._v(" "),_c('div',{attrs:{"name":"termly-embed","data-id":"6b234117-74c2-461c-a0b1-29611277dd1c","data-type":"iframe"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }